import type { DashLightingPack } from './types';

/**
 * All-glow pack: no opaque white on-state. Relays light up behind the avatar
 * (blue non-PM / green PM with power-scaled radius). Lights, sensors, emeters keep glow.
 */
export const GLOW_ALL_DASH_LIGHTING_PACK: DashLightingPack = {
	id: 'glow-all',
	types: {
		'S4PB-00CU000002': { preset: 'light-color', colorFrom: 'cury-ambient', surfaceMode: 'glow' },
	},
	categories: {
		relay: { preset: 'sensor', colorFrom: 'relay-power', surfaceMode: 'glow' },
		'relay-pm': { preset: 'sensor', colorFrom: 'relay-power', surfaceMode: 'glow' },
		light: { preset: 'light-color', colorFrom: 'device', surfaceMode: 'glow' },
		lights: { preset: 'light-color', colorFrom: 'device', surfaceMode: 'glow' },
		rgbw: { preset: 'light-color', colorFrom: 'device', surfaceMode: 'glow' },
		bulb: { preset: 'light-color', colorFrom: 'device', surfaceMode: 'glow' },
		sensor: { preset: 'sensor', surfaceMode: 'glow' },
		emeter: { preset: 'sensor', surfaceMode: 'glow' },
		power_meter: { preset: 'sensor', surfaceMode: 'glow' },
		pv: { preset: 'sensor', surfaceMode: 'glow' },
	},
	modes: {
		light: { preset: 'light-color', colorFrom: 'device', surfaceMode: 'glow' },
		white: { preset: 'light-color', colorFrom: 'device', surfaceMode: 'glow' },
		color: { preset: 'light-color', colorFrom: 'device', surfaceMode: 'glow' },
	},
	refinements: {
		alertStatus: { preset: 'sensor-alert', surfaceMode: 'glow' },
		htTemperature: { colorFrom: 'ht' },
		deviceState: {
			preset: 'device-state',
			accents: {
				offline: '--color-3',
				warning: '--color-warning',
				muted: '--color-3',
			},
		},
	},
	fallback: {
		withToggle: { preset: 'sensor', colorFrom: 'relay-power', surfaceMode: 'glow' },
		withoutToggle: { preset: 'sensor', surfaceMode: 'glow' },
	},
};
